export function parseBase64JsonUtf8(base64: string): unknown {
  const binary = atob(base64)
  const bytes = Uint8Array.from(binary, char => char.charCodeAt(0))
  const json = new TextDecoder('utf-8').decode(bytes)
  return JSON.parse(json)
}
